/* eslint-disable no-new */
import { SwitchTheme } from './switch-theme';

const build = () => {
  new SwitchTheme();
};

export default build;
